import { ReactNode, createContext, useCallback, useContext, useMemo } from 'react';
import { activityManager } from '../activityManagerInstance';
import { StudyEventContext } from '../type';

export const ActivityManagerContext = createContext<StudyEventContext>({});

interface ActivityManagerContextProviderProps {
  children: ReactNode;
  context: StudyEventContext;
}

export const ActivityManagerContextProvider = (props: ActivityManagerContextProviderProps) => {
  const { children, context: contextProp } = props;
  const parentValue = useContext(ActivityManagerContext);

  const context = useMemo(() => {
    return {
      ...parentValue,
      ...contextProp,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify({ contextProp, parentValue })]);

  return <ActivityManagerContext.Provider value={context}>{children}</ActivityManagerContext.Provider>;
};

export const useActivityManagerContext = () => {
  const dataContext = useContext(ActivityManagerContext);

  const logAction: typeof activityManager.logAction = useCallback(
    (actionContext) =>
      activityManager.logAction({
        ...actionContext,
        data: {
          ...dataContext,
          ...actionContext.data,
        },
      }),
    [dataContext],
  );

  const startSpan: typeof activityManager.startSpan = useCallback(
    (spanContext) =>
      activityManager.startSpan({
        ...spanContext,
        data: {
          ...dataContext,
          ...spanContext.data,
        },
      }),
    [dataContext],
  );

  return {
    context: dataContext,
    logAction,
    startSpan,
  };
};
